import { render, staticRenderFns } from "./addCoupon.vue?vue&type=template&id=1417a298&scoped=true"
import script from "./addCoupon.vue?vue&type=script&lang=js"
export * from "./addCoupon.vue?vue&type=script&lang=js"
import style0 from "./addCoupon.vue?vue&type=style&index=0&id=1417a298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1417a298",
  null
  
)

export default component.exports